const previewFormWidth = "100%";

export default previewFormWidth;
